import { WsCore } from './ws.core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { Observable } from 'rxjs';
import { Club } from '../selected-club.service';

export class WsClubs extends WsCore {
     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
     }

     browseClub(params: { q?; postalCode?; city?; company?; obId? }) {
          return this.http.get(
               window.app.cloudHeitzBaseUrl +
                    '/clientGroup/' +
                    window.app.club.groupId +
                    '/clients',
               {
                    params: params,
               }
          ) as Observable<Club[]>;
     }
}
